export default "__VITE_ASSET__3fb33cfa__"